import type { JQLMessage } from './types.tsx';

export function jqlMessagesToErrors(jqlMessages?: JQLMessage[]) {
	return jqlMessages
		?.filter((message) => message.type === 'error')
		.map((message) => message.message?.toString())
		.filter(Boolean);
}
